import { Identify } from '@amplitude/analytics-browser';
import amplitude from 'lib/analytics';
import type {
  MARKETING_PREFERENCES_FORM_VARIANT,
  MarketingPreferencesVerticals
} from 'components/MarketingPreferences';

export const trackMarketingPreferences = (
  ref: 'signup' | 'account' | 'modal',
  marketingPreferencesVerticals: MarketingPreferencesVerticals
) => {
  amplitude.track('Marketing Preferences Saved', {
    Ref: ref,
    ...marketingPreferencesVerticals
  });

  const identifyEvent = new Identify();
  Object.keys(marketingPreferencesVerticals).forEach((verticalKey) => {
    const verticalPreferences =
      marketingPreferencesVerticals[verticalKey as keyof typeof MARKETING_PREFERENCES_FORM_VARIANT];
    identifyEvent.set(verticalKey, verticalPreferences);
  });
  amplitude.identify(identifyEvent);
};
